import { render, staticRenderFns } from "./assessment-standard.vue?vue&type=template&id=1635dd62&scoped=true&"
import script from "./assessment-standard.vue?vue&type=script&lang=js&"
export * from "./assessment-standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635dd62",
  null
  
)

export default component.exports